import axiosInstance from "./AxiosInstanceMain";

export const createFbTokenApi = async (data) => {
  const res = await axiosInstance.post(
    "/admin/leadControls/create-token",
    data
  );
  return res.data;
};

export const getFbTokensApi = async () => {
  const res = await axiosInstance.get(
    "/admin/leadControls/tokens"
  );
  return res.data;
};

export const getFbTokenByIdApi = async (id) => {
  const res = await axiosInstance.get(
    `/admin/leadControls/token/${id}`
  );
  return res.data;
};

export const updateFbTokenApi = async (id, data) => {
  const res = await axiosInstance.put(
    `/admin/leadControls/update-token/${id}`,
    data
  );
  return res.data;
};

export const deleteFbTokenApi = async (id) => {
  const res = await axiosInstance.delete(
    `/admin/leadControls/delete-token/${id}`
  );
  return res.data;
};
export const extendUserTokenApi = async (data) => {
  const res = await axiosInstance.post("/admin/fb-leadgen/extend-user-token", data);
  return res.data;
};

export const getUserTokensApi = async () => {
  const res = await axiosInstance.get("/admin/fb-leadgen/user-tokens");
  return res.data;
};

export const fetchPagesApi = async (data) => {
  const res = await axiosInstance.post("/admin/fb-leadgen/fetch-pages", data);
  return res.data;
};

export const savePagesApi = async (data) => {
  const res = await axiosInstance.post("/admin/fb-leadgen/save-pages", data);
  return res.data;
};
